"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGHFOrderCloseInfo = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const useGHFOrderCloseInfo = (props) => {
    const { exchangeOrder, trend, curPrice, takerFeeRate } = props;
    const estimateClosePositionFee = (0, react_1.useMemo)(() => {
        const calcluateEstimateClosePosition = (trendParam) => {
            var _a;
            // 平仓手续费公式 = 仓位 * 当前价 * 手续费率
            const trendOrder = (_a = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder) === null || _a === void 0 ? void 0 : _a[trendParam];
            if (trendOrder) {
                return new trade_utils_lib_1.SafeDecimal(curPrice).mul(new trade_utils_lib_1.SafeDecimal(takerFeeRate)).mul(new trade_utils_lib_1.SafeDecimal(trendOrder.position).abs());
            }
            return new trade_utils_lib_1.SafeDecimal(0);
        };
        if (trend) {
            return calcluateEstimateClosePosition(trend);
        }
        else {
            return calcluateEstimateClosePosition(TradeAPILib_1.GridFuturesTrend.long).add(calcluateEstimateClosePosition(TradeAPILib_1.GridFuturesTrend.short));
        }
    }, [curPrice, exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder, takerFeeRate, trend]);
    const currentTotalProfit = (0, react_1.useMemo)(() => {
        const calculateCurrentTotalProfit = (trendParam) => {
            var _a;
            // 最终总利润 = 当前订单总利润
            const trendOrder = (_a = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder) === null || _a === void 0 ? void 0 : _a[trendParam];
            if (trendOrder) {
                return new trade_utils_lib_1.SafeDecimal(trendOrder.totalProfit);
            }
            return new trade_utils_lib_1.SafeDecimal(0);
        };
        if (trend) {
            return calculateCurrentTotalProfit(trend);
        }
        else {
            return calculateCurrentTotalProfit(TradeAPILib_1.GridFuturesTrend.long).add(calculateCurrentTotalProfit(TradeAPILib_1.GridFuturesTrend.short));
        }
    }, [exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder, trend]);
    const currentTotalProfitAfterFee = (0, react_1.useMemo)(() => {
        // 最终总利润 = 当前订单总利润 - 预估关单手续费
        return currentTotalProfit.minus(estimateClosePositionFee);
    }, [currentTotalProfit, estimateClosePositionFee]);
    return {
        estimateClosePositionFee,
        currentTotalProfit,
        currentTotalProfitAfterFee,
    };
};
exports.useGHFOrderCloseInfo = useGHFOrderCloseInfo;
